<template>
  <div class="page-container">
    <div class="main">
      <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div>

      <page :url="url" :dataList.sync="dataList" :form="form">
        <template slot="tableSearch">
          <el-form-item label="路由名称" prop="name">
            <el-input v-model="form.name" placeholder="路由名称"></el-input>
          </el-form-item>
          <el-form-item label="是否锁定" prop="isLocked">
            <el-select v-model="form.isLocked" placeholder="是否锁定">
              <el-option label="请选择" value=""></el-option>
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
            </el-select>
          </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button type="primary" @click="addRole" size="small"
            >添加路由</el-button
          >
        </template>
        <template slot="tableColumn">
          <el-table-column prop="id" label="编号"> </el-table-column>
          <el-table-column prop="name" label="角色名称"> </el-table-column>
          <el-table-column prop="url" label="路由地址"> </el-table-column>
          <el-table-column prop="parentName" label="所属路由">
          </el-table-column>
          <el-table-column prop="systemName" label="所属系统">
          </el-table-column>
          <el-table-column prop="level" label="等级"> </el-table-column>
          <el-table-column
            prop="isLocked"
            :formatter="$formatter.formatBoolean"
            label="是否锁定"
          >
          </el-table-column>
          <el-table-column
            fixed="right"
            align="center"
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="roleEdit(scope.row)"
                >编辑</el-button
              >
              <el-button type="text" size="small" @click="routerDel(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </template>
      </page>
    </div>
    <system_router_edit
      :show.sync="showAddUserDialog"
      :value="value"
      :isShow="isShow"
    ></system_router_edit>
  </div>
</template>


<script>
import Page from "../../components/Page.vue";
import SystemRouterEdit from "../../components/auth/SystemRouterEdit.vue";

export default {
  components: {
    page: Page,
    system_router_edit: SystemRouterEdit,
  },
  data() {
    return {
      form: {
        name: "",
        isLocked: "",
      },
      url: "/sysRouterInfo/selectList",
      dataList: [], //双向绑定获取数据
      spanArr: [],
      isShow: false,
      showAddUserDialog: false,
      value: {},
      systemList: [],
    };
  },
  methods: {
    roleEdit(row) {
      console.log(row);

      let isLocked = row.isLocked ? "1" : "0";
      console.log(isLocked);

      let obj = {};
      obj.routerName = row.name;
      obj.isLocked = isLocked;
      obj.parentId = row.parentId;
      obj.url = row.url;
      obj.id = row.id;
      obj.sysId = row.sysId;
      obj.parentName = row.parentName;
      this.value = obj;
      this.isShow = true;
      this.showAddUserDialog = true;
    },
    routerDel(row) {
      this.$confirm("此操作将永久删除该菜单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(JSON.stringify(row));
          this.$axios
            .post("/api/sysRouterInfo/delRouter", { id: row.id })
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.$bus.$emit("refresh"); //通知刷新
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            });
        })
        .catch(() => {});
    },
    addRole(row) {
      this.value = {};
      this.action = "addRole";
      this.formData = row;
      this.isShow = false;
      this.showAddUserDialog = true;
    },
  },
  created() {},
};
</script>
<style scoped>
</style>